import { FC } from 'react'
import { IconButton } from '@mui/material'
import { MqttStatus } from '../../API/types'
import { DirectionsWalk, Lightbulb, SensorDoor, Lock } from '@mui/icons-material'
import DL1ControllerStatus from './DL1ControllerStatus'

interface IRoomControllerStatusProps {
  controllerId: string
  mqttDeviceStatus?: MqttStatus | undefined
}

const RoomControllerStatus: FC<IRoomControllerStatusProps> = ({ controllerId, mqttDeviceStatus }) => {
  return (
    <>
      {controllerId === 'DL1' ? (
        <DL1ControllerStatus controllerId={controllerId} mqttDeviceStatus={mqttDeviceStatus} />
      ) : (
        <>
          <IconButton
            //color='success'
            component='div'
            sx={{ cursor: 'default' }}
          >
            <DirectionsWalk />
          </IconButton>
          <IconButton
            //color='success'
            component='div'
            sx={{ cursor: 'default' }}
          >
            <Lightbulb />
          </IconButton>
          <IconButton
            //color='success'
            component='div'
            sx={{ cursor: 'default' }}
          >
            <Lock />
          </IconButton>
          <IconButton
            //color='success'
            component='div'
            sx={{ cursor: 'default' }}
          >
            <SensorDoor />
          </IconButton>
        </>
      )}
    </>
  )
}

export default RoomControllerStatus
